import * as React from "react";
import { Context } from "./_context";
export const NextIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22.207 11.293a1 1 0 0 1 0 1.414l-8.5 8.5-1.414-1.414L19.086 13H1.5v-2h17.586l-6.793-6.793 1.414-1.414 8.5 8.5Z", fill: "currentColor" }));
  return iconset[size];
};
NextIcon.iconId = "Pzp58t";
